import React from 'react';
import Svg, { Circle, Line, Path, Polyline, Rect } from 'react-native-svg';

const stroke = (color, strokeWidth) => ({
  stroke: color,
  strokeWidth,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

const LeafGlyph = ({ color, strokeWidth }) => (
  <>
    <Path d="M12 20V11.5" fill="none" {...stroke(color, strokeWidth)} />
    <Path d="M12 12.5C8.8 12.5 6 9.8 6 6.6c3.2 0 6 2.7 6 5.9Z" fill="none" {...stroke(color, strokeWidth)} />
    <Path d="M12 12.5c3.2 0 6-2.7 6-5.9-3.2 0-6 2.7-6 5.9Z" fill="none" {...stroke(color, strokeWidth)} />
  </>
);

const SunGlyph = ({ color, strokeWidth }) => (
  <>
    <Circle cx="12" cy="12" r="4.2" fill="none" {...stroke(color, strokeWidth)} />
    <Line x1="12" y1="3.2" x2="12" y2="5.5" {...stroke(color, strokeWidth)} />
    <Line x1="12" y1="18.5" x2="12" y2="20.8" {...stroke(color, strokeWidth)} />
    <Line x1="3.2" y1="12" x2="5.5" y2="12" {...stroke(color, strokeWidth)} />
    <Line x1="18.5" y1="12" x2="20.8" y2="12" {...stroke(color, strokeWidth)} />
    <Line x1="5.6" y1="5.6" x2="7.2" y2="7.2" {...stroke(color, strokeWidth)} />
    <Line x1="16.8" y1="16.8" x2="18.4" y2="18.4" {...stroke(color, strokeWidth)} />
    <Line x1="16.8" y1="7.2" x2="18.4" y2="5.6" {...stroke(color, strokeWidth)} />
    <Line x1="5.6" y1="18.4" x2="7.2" y2="16.8" {...stroke(color, strokeWidth)} />
  </>
);

const CloudGlyph = ({ color, strokeWidth }) => (
  <Path
    d="M6.4 17.2h10.7a3.6 3.6 0 1 0-.8-7.1A4.7 4.7 0 0 0 7.8 11a3.1 3.1 0 0 0-1.4 6.2Z"
    fill="none"
    {...stroke(color, strokeWidth)}
  />
);

export default function PadiProIcon({
  name = 'default',
  size = 20,
  color = '#0E5B3A',
  secondary = '#8BC5A8',
  strokeWidth = 1.8,
}) {
  const c = color;
  const w = strokeWidth;

  const renderGlyph = () => {
    switch (name) {
      case 'archive':
        return (
          <>
            <Path d="M5 8.3h14v10.2a1.8 1.8 0 0 1-1.8 1.8H6.8A1.8 1.8 0 0 1 5 18.5V8.3Z" fill="none" {...stroke(c, w)} />
            <Rect x="4" y="4.2" width="16" height="4.1" rx="1.2" fill="none" {...stroke(c, w)} />
            <Line x1="9.3" y1="12.2" x2="14.7" y2="12.2" {...stroke(c, w)} />
          </>
        );
      case 'inventory':
        return (
          <>
            <Rect x="4.5" y="7" width="15" height="12.5" rx="2.4" fill="none" {...stroke(c, w)} />
            <Path d="M8 7V5.8C8 4.8 8.8 4 9.8 4h4.4c1 0 1.8.8 1.8 1.8V7" fill="none" {...stroke(c, w)} />
            <Line x1="4.5" y1="11" x2="19.5" y2="11" {...stroke(c, w)} />
          </>
        );
      case 'expenses':
        return (
          <>
            <Rect x="3.8" y="6.5" width="16.4" height="11.8" rx="2.7" fill="none" {...stroke(c, w)} />
            <Path d="M20.2 10.5h-3.8a2.2 2.2 0 1 0 0 4.4h3.8" fill="none" {...stroke(c, w)} />
            <Circle cx="16.4" cy="12.7" r="0.9" fill={c} />
          </>
        );
      case 'scanner':
        return (
          <>
            <Path d="M7 4.5H4.8v2.2" fill="none" {...stroke(c, w)} />
            <Path d="M17 4.5h2.2v2.2" fill="none" {...stroke(c, w)} />
            <Path d="M7 19.5H4.8v-2.2" fill="none" {...stroke(c, w)} />
            <Path d="M17 19.5h2.2v-2.2" fill="none" {...stroke(c, w)} />
            <Rect x="8.4" y="8.4" width="7.2" height="7.2" rx="1.8" fill="none" {...stroke(c, w)} />
            <Line x1="12" y1="9.4" x2="12" y2="14.6" {...stroke(c, w)} />
          </>
        );
      case 'operations':
        return (
          <>
            <Line x1="6" y1="7" x2="18" y2="7" {...stroke(c, w)} />
            <Line x1="6" y1="12" x2="18" y2="12" {...stroke(c, w)} />
            <Line x1="6" y1="17" x2="18" y2="17" {...stroke(c, w)} />
            <Circle cx="9" cy="7" r="1.8" fill="#fff" {...stroke(c, w)} />
            <Circle cx="15" cy="12" r="1.8" fill="#fff" {...stroke(c, w)} />
            <Circle cx="11" cy="17" r="1.8" fill="#fff" {...stroke(c, w)} />
          </>
        );
      case 'measure':
        return (
          <>
            <Path d="M5.2 18.3 7.4 6.7l9.1-2 2.3 11.7-13.6 1.9Z" fill="none" {...stroke(c, w)} />
            <Circle cx="7.4" cy="6.7" r="1.2" fill={secondary} {...stroke(c, w)} />
            <Circle cx="18.8" cy="16.4" r="1.2" fill={secondary} {...stroke(c, w)} />
            <Line x1="9.2" y1="15.7" x2="15.8" y2="14.6" {...stroke(c, w)} />
            <Line x1="10.1" y1="13.7" x2="10.5" y2="16.6" {...stroke(c, w)} />
            <Line x1="13" y1="13.2" x2="13.4" y2="16.1" {...stroke(c, w)} />
          </>
        );
      case 'tractor':
        return (
          <>
            <Path d="M4.2 15.8h8.3V10h3.1l2.2 3.2h1.8v2.6h-1.2" fill="none" {...stroke(c, w)} />
            <Path d="M12.5 10V7.2h3.2v2.8" fill="none" {...stroke(c, w)} />
            <Line x1="7.3" y1="15.8" x2="15.5" y2="15.8" {...stroke(c, w)} />
            <Circle cx="7.3" cy="17.2" r="2.5" fill="none" {...stroke(c, w)} />
            <Circle cx="16.8" cy="17.2" r="1.8" fill="none" {...stroke(c, w)} />
            <Line x1="4.2" y1="12.2" x2="8.2" y2="12.2" {...stroke(c, w)} />
          </>
        );
      case 'monitoring':
        return (
          <>
            <Path d="M3.6 12c2.1-3.6 5-5.4 8.4-5.4s6.3 1.8 8.4 5.4c-2.1 3.6-5 5.4-8.4 5.4S5.7 15.6 3.6 12Z" fill="none" {...stroke(c, w)} />
            <Circle cx="12" cy="12" r="2.4" fill="none" {...stroke(c, w)} />
            <Path d="M12 6.2v-2M8.1 7.4 6.7 5.9M15.9 7.4l1.4-1.5" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'calendar':
        return (
          <>
            <Rect x="4.5" y="5.8" width="15" height="13.7" rx="2.4" fill="none" {...stroke(c, w)} />
            <Line x1="8.2" y1="4.2" x2="8.2" y2="7.2" {...stroke(c, w)} />
            <Line x1="15.8" y1="4.2" x2="15.8" y2="7.2" {...stroke(c, w)} />
            <Line x1="4.8" y1="9.6" x2="19.2" y2="9.6" {...stroke(c, w)} />
            <Circle cx="9" cy="13" r="0.8" fill={c} />
            <Circle cx="12" cy="13" r="0.8" fill={secondary} />
            <Circle cx="15" cy="16" r="0.8" fill={c} />
          </>
        );
      case 'report':
        return (
          <>
            <Rect x="5.5" y="4.5" width="13" height="15" rx="2.2" fill="none" {...stroke(c, w)} />
            <Line x1="9" y1="15.8" x2="9" y2="11.8" {...stroke(c, w)} />
            <Line x1="12" y1="15.8" x2="12" y2="9.5" {...stroke(c, w)} />
            <Line x1="15" y1="15.8" x2="15" y2="13.3" {...stroke(c, w)} />
          </>
        );
      case 'harvest':
      case 'panen':
        return (
          <>
            <Path d="M11 4.5v15.2" fill="none" {...stroke(c, w)} />
            <Path d="M11.2 7.2c2.5-.2 4-1.8 4.7-3.3-2.3.2-4.1 1.1-4.7 3.3Z" fill="none" {...stroke(c, w)} />
            <Path d="M11.2 10.6c2.5-.2 4-1.8 4.7-3.3-2.3.2-4.1 1.1-4.7 3.3Z" fill="none" {...stroke(c, w)} />
            <Path d="M11.2 14c2.5-.2 4-1.8 4.7-3.3-2.3.2-4.1 1.1-4.7 3.3Z" fill="none" {...stroke(c, w)} />
            <Path d="M10.8 9.4c-1.8-.5-3.3-1.7-4-3.4 1.8.4 3.3 1.5 4 3.4Z" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'semprot':
        return (
          <>
            <Rect x="6.2" y="9.1" width="7.4" height="9.2" rx="1.8" fill="none" {...stroke(c, w)} />
            <Path d="M9.4 9.1V6.4h4.2" fill="none" {...stroke(c, w)} />
            <Line x1="13.6" y1="7.8" x2="18.8" y2="7.8" {...stroke(c, w)} />
            <Circle cx="19.6" cy="7.8" r="1.2" fill="none" {...stroke(c, w)} />
            <Circle cx="18.4" cy="10.8" r="0.7" fill={secondary} />
            <Circle cx="20.2" cy="12.2" r="0.7" fill={secondary} />
          </>
        );
      case 'pupuk':
        return (
          <>
            <Path d="M7.2 7.2h9.6l-1.2 11H8.4l-1.2-11Z" fill="none" {...stroke(c, w)} />
            <Path d="M9.5 7.2a2.6 2.6 0 0 1 5 0" fill="none" {...stroke(c, w)} />
            <Path d="M12 15v-4.4" fill="none" {...stroke(c, w)} />
            <Path d="M12 10.6c-1.8 0-3.2-1.6-3.2-3.2 1.8 0 3.2 1.4 3.2 3.2Z" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'air':
        return (
          <Path
            d="M12 4.4c3.2 3.7 5.1 6.4 5.1 8.7a5.1 5.1 0 1 1-10.2 0c0-2.3 1.9-5 5.1-8.7Z"
            fill="none"
            {...stroke(c, w)}
          />
        );
      case 'gulma':
      case 'stage-bunting':
        return <LeafGlyph color={c} strokeWidth={w} />;
      case 'catatan':
        return (
          <>
            <Rect x="6" y="4.8" width="12" height="14.4" rx="1.8" fill="none" {...stroke(c, w)} />
            <Line x1="9" y1="9" x2="15" y2="9" {...stroke(c, w)} />
            <Line x1="9" y1="12" x2="15" y2="12" {...stroke(c, w)} />
            <Line x1="9" y1="15" x2="13" y2="15" {...stroke(c, w)} />
          </>
        );
      case 'foto':
        return (
          <>
            <Rect x="4.5" y="7.2" width="15" height="10.8" rx="2.2" fill="none" {...stroke(c, w)} />
            <Path d="M8.2 7.2 9.4 5.5h5.2l1.2 1.7" fill="none" {...stroke(c, w)} />
            <Circle cx="12" cy="12.6" r="2.7" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'stage-vegetatif':
        return (
          <>
            <Path d="M12 19v-7.5" fill="none" {...stroke(c, w)} />
            <Path d="M12 11.8C9.5 11.8 7.3 9.7 7.3 7.1c2.5 0 4.7 2 4.7 4.7Z" fill="none" {...stroke(c, w)} />
            <Path d="M12 11.8c2.5 0 4.7-2.1 4.7-4.7-2.5 0-4.7 2-4.7 4.7Z" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'stage-heading':
        return (
          <>
            <Path d="M11.6 5.3V19" fill="none" {...stroke(c, w)} />
            <Path d="M11.8 7.4c2.2-.2 3.6-1.7 4.3-3.1-2.2.2-3.7 1.1-4.3 3.1Z" fill="none" {...stroke(c, w)} />
            <Path d="M11.8 10.4c2.2-.2 3.6-1.7 4.3-3.1-2.2.2-3.7 1.1-4.3 3.1Z" fill="none" {...stroke(c, w)} />
            <Path d="M11.8 13.4c2.2-.2 3.6-1.7 4.3-3.1-2.2.2-3.7 1.1-4.3 3.1Z" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'stage-filling':
        return (
          <>
            <Circle cx="9.2" cy="12" r="2.4" fill="none" {...stroke(c, w)} />
            <Circle cx="14.8" cy="9.2" r="2.1" fill="none" {...stroke(c, w)} />
            <Circle cx="14.8" cy="14.8" r="2.1" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'stage-ripening':
        return <SunGlyph color={c} strokeWidth={w} />;
      case 'weather-ok':
        return <SunGlyph color={c} strokeWidth={w} />;
      case 'weather-warn':
        return <CloudGlyph color={c} strokeWidth={w} />;
      case 'weather-hold':
        return (
          <>
            <CloudGlyph color={c} strokeWidth={w} />
            <Path d="M8.8 18.7v1.8M12 18.7v1.8M15.2 18.7v1.8" fill="none" {...stroke(c, w)} />
          </>
        );
      case 'logout':
        return (
          <>
            <Path d="M9.5 4.8H6.9a2.1 2.1 0 0 0-2.1 2.1v10.2a2.1 2.1 0 0 0 2.1 2.1h2.6" fill="none" {...stroke(c, w)} />
            <Path d="M13.4 16.2 18 12l-4.6-4.2" fill="none" {...stroke(c, w)} />
            <Line x1="8.8" y1="12" x2="18" y2="12" {...stroke(c, w)} />
          </>
        );
      default:
        return (
          <>
            <Circle cx="12" cy="12" r="3.8" fill="none" {...stroke(c, w)} />
            <Polyline points="12,4.5 13.4,7.5 16.6,8.4 14.4,10.8 14.8,14 12,12.6 9.2,14 9.6,10.8 7.4,8.4 10.6,7.5" fill="none" {...stroke(c, w)} />
          </>
        );
    }
  };

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {renderGlyph()}
    </Svg>
  );
}
